import React from "react";

import "./StepHeading.css";

const StepHeading = (props) => {
  const customClass =
    props?.className && props.className.length > 0 ? ` ${props.className}` : "";
  const className = `dialog-step-heading${customClass}`;

  return (
    <div className={className}>
      <span className="step-heading-label">
        <strong>{props?.label}:</strong>
      </span>
      <span className="step-heading-value">{props?.value}</span>
    </div>
  );
};

export default StepHeading;
